/**
 * user mutations
 */
export const SET_SMS_CODE = 'SET_SMS_CODE';
export const STORE_USER = 'STORE_USER';

/**
 * vuex mutation for Loader screen
 */
export const TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE = 'TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_TRUE';
export const TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE = 'TOGGLE_PRELOADER_AXIOS_REQUEST_SCREEN_TO_FALSE';
